import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ready && user && user.role === "admin") nav("/admin");
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await login(email, password);
      if (u.role === "admin") nav("/admin");
      else setError("This account does not have admin privileges.");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page">
      <Navbar />
      <section className="max-w-md mx-auto px-6 pt-32 pb-24">
        <div className="glass rounded-sm p-10">
          <div className="flex items-center gap-2 mb-6">
            <ShieldCheck className="w-5 h-5 text-[var(--pov-cyan)]" />
            <p className="overline">Practice Dashboard</p>
          </div>
          <h1 className="font-display font-light text-3xl tracking-tight">Sign in</h1>
          <p className="text-white/60 text-sm mt-2">Restricted to practice administrators.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <input className="input" type="email" placeholder="Email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-email" />
            <input className="input" type="password" placeholder="Password" required value={password} onChange={e => setPassword(e.target.value)} data-testid="admin-password" />
            {error ? <p className="text-sm text-[var(--pov-coral)]" data-testid="admin-login-error">{error}</p> : null}
            <button className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign In
            </button>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}
